import store from 'APP_ROOT/store';
import getFormSuccess from 'APP_ROOT/actions/get-form-success';
import getFormPresentation from 'APP_ROOT/actions/get-form-presentation';

/**
 * Seed the redux store from a raw template JSON, replicating the essential
 * two dispatches of the app's `createNewForm` flow (minus the API fetch and
 * the post-create side effects):
 *
 *   1. getFormSuccess(template)
 *        → reducer keys the template under `form.templates[kebabCase(type)]`
 *          and sets `selectedForm.template`/`presentation` to that key string.
 *   2. getFormPresentation({ schema, type, validations, enums, overrides })
 *        → pure transform → `form.presentations[type]` + `selectedForm.data`.
 *
 * The `getSelectedForm` selector then rehydrates `selectedForm.template` /
 * `.presentation` from those maps, giving the renderer the shape it expects.
 *
 * Templates use `formSchema` (most) or `jsonSchema` (a few); both are accepted.
 */
export default function seedTemplate(rawTemplate) {
  const formSchema = rawTemplate.formSchema || rawTemplate.jsonSchema || {};
  const type = rawTemplate.type || 'preview-template';
  const template = { ...rawTemplate, type, formSchema };

  store.dispatch(getFormSuccess(template));
  // getFormPresentation is an async thunk — return its promise so callers can
  // await it and surface transform-time failures (not just synchronous ones).
  return store.dispatch(
    getFormPresentation({
      schema: formSchema.form || {},
      type,
      validations: formSchema.validations || {},
      enums: formSchema.enums || {},
      overrides: formSchema.overrides,
    })
  );
}
